import _styled from "@emotion/styled/base";
import PropTypes from 'prop-types';
import { Icon, colorsRaw } from 'decap-cms-ui-default';

/**
 * The header's deploy indicator: state between the save toast and the "live"
 * one needs a place that is not an interruption. It is the nav item itself,
 * not a badge beside it, so there are not two doors to the same page.
 */
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const DotIcon = /*#__PURE__*/_styled(Icon, {
  target: "ev9m3q80",
  label: "DotIcon"
})("color:", props => props.color, ";flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

/** The `circle` icon rather than a styled span, so it lines up with the other nav icons. */
export function StatusDot({
  color
}) {
  return _jsx(DotIcon, {
    type: "circle",
    color: color
  });
}
StatusDot.propTypes = {
  color: PropTypes.string.isRequired
};

/** `yellow` is a pale background tint, invisible as a dot, so in-progress uses brown. */
export const DEPLOY_STATE_COLORS = {
  success: colorsRaw.green,
  failed: colorsRaw.redDark,
  building: colorsRaw.brown,
  pending: colorsRaw.brown,
  canceled: colorsRaw.gray,
  // Not a host state: a build that stopped being mentioned, so no outcome.
  stalled: colorsRaw.gray
};

/**
 * How long an unfinished deploy may go unmentioned before we stop calling it
 * "building": a deleted branch's preview is never reported again. Generous, so
 * it never overtakes a slow but healthy build.
 */
export const STALE_AFTER_MS = 30 * 60 * 1000;

/**
 * Whether an unfinished deploy has gone quiet too long to call it "building".
 * Presentation only: going quiet is not the same claim as failing.
 */
export function isStaleDeploy(row, now = Date.now()) {
  if (!row || row.state !== 'building' && row.state !== 'pending') {
    return false;
  }
  const at = Date.parse(row.updated_at);
  return Number.isFinite(at) && now - at > STALE_AFTER_MS;
}

/**
 * What the nav item says and what colour its dot is. Publishing beats
 * everything: an editor with a save in flight is asking about that save.
 */
export function deployIndicator(pendingCount, latest, now = Date.now()) {
  if (pendingCount > 0) {
    return {
      key: 'app.header.deploysPublishing',
      color: DEPLOY_STATE_COLORS.building
    };
  }
  // A stale build must not say "Building" forever: waiting will not help.
  if (!latest || isStaleDeploy(latest, now)) {
    return {
      key: 'app.header.deploys',
      color: colorsRaw.gray
    };
  }
  if (latest.state === 'failed') {
    return {
      key: 'app.header.deploysFailed',
      color: DEPLOY_STATE_COLORS.failed
    };
  }
  if (latest.state === 'building' || latest.state === 'pending') {
    return {
      key: 'app.header.deploysBuilding',
      color: DEPLOY_STATE_COLORS.building
    };
  }
  // `canceled` counts as deployed: the site still serves the last success, and
  // a superseded build's change ships inside the newer one.
  return {
    key: 'app.header.deploysDeployed',
    color: DEPLOY_STATE_COLORS.success
  };
}